import { createAction } from '@reduxjs/toolkit';

import { actionType } from './actionType';

export const sendLog = createAction<Record<string, string | undefined>>(actionType.SEND_LOG_REQUEST);
